export default __webpack_public_path__ + "static/media/fauna-gql-dropoff.408614fd.png";